module.exports = __webpack_public_path__ + "img/cv.0351424b.svg";